@if (file) {
  <div
    class="file-card {{ isSelected(file!) && selectable ? 'selected' : '' }} d-flex flex-column justify-content-between overflow-hidden"
    data-testid="document-preview-tile"
    [attr.data-file-type]="file!.type"
    [attr.data-file-name]="file!.filename"
    [attr.data-openable]="hasTileAction(file!)"
    [attr.data-selected]="isSelected(file!) && selectable"
    [attr.role]="hasTileAction(file!) ? 'link' : null"
    [attr.tabindex]="hasTileAction(file!) ? '0' : null"
    [attr.aria-label]="hasTileAction(file!) ? 'Open ' + file!.filename : null"
    (click)="onTileClick(file!)"
    (keydown)="onTileKeydown($event, file!)"
  >
    <div class="file-icon-section position-relative d-flex align-items-center justify-content-center">
      @if (file!.type === 'image' && imageSource) {
        <img [ngSrc]="imageSource" [disableOptimizedSrcset]="file!.path.endsWith('.gif')" [width]="150" [height]="100" [sizes]="'100vw, 100vw, 100vw'" [alt]="file!.filename" priority="low" class="file-image" appNgSrcImageError />
      }
      @if (file!.type !== 'file' && file!.type !== 'image' && file!.preview) {
        <img [ngSrc]="file!.preview" [width]="150" [height]="100" [sizes]="'100vw, 100vw, 100vw'" [alt]="file!.filename" priority="low" class="file-image" appNgSrcImageError />
      }
      @if (file!.type !== 'file') {
        <div class="image-preview-overlay" (click)="onTileClick(file!); $event.stopPropagation()"></div>
      }
      @if (file!.type === 'file') {
        <div class="fileIcons" data-testid="document-preview-file-body" (click)="onTileClick(file!); $event.stopPropagation()">
          <div class="file-icon-container" [class]="documentService.getDocumentClass(file!)">
            <span class="fileIconBase mts-icon mts-icon-filled notranslate fs-l lh-base" translate="no">insert_drive_file</span>
            <div class="file-type">{{ documentService.getDocumentExtension(file!) }}</div>
          </div>
        </div>
      }
      <div data-testid="document-preview-info" (click)="$event.stopPropagation()">
        <app-tooltip [type]="'File'" [opensOn]="'Auto'" [file]="file" [icon]="'info'" [cssClass]="'p-2'"></app-tooltip>
      </div>
      @if (file!.type === 'image' || file!.type === 'video') {
        <div class="position-absolute top-0 end-0 me-2 me-sm-1 mt-1 mt-sm-0 icons" data-testid="document-preview-gallery" (click)="openGallery($event, file!)">
          <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [fontColor]="'text-white'" [icon]="'visibility'"></app-icon-badge>
        </div>
      }
      @if (file!.type !== 'image' && file!.type !== 'video') {
        <div class="position-absolute top-0 end-0 me-2 me-sm-1 mt-1 mt-sm-0 icons" data-testid="document-preview-download" (click)="downloadDocumentFromAction($event, file!)">
          <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [fontColor]="'text-white'" [icon]="'file_download'"></app-icon-badge>
        </div>
      }
      <div class="position-absolute bottom-0 end-0 me-2 me-sm-1 mb-1 mb-sm-0 icons selected-icon" data-testid="document-preview-selected-status" (click)="$event.stopPropagation()">
        <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [icon]="'task_alt'"></app-icon-badge>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center flex-grow-1 px-2 py-1" (click)="onTileClick(file!); $event.stopPropagation()">
      <span class="truncate-text-two-lines text-center overflow-hidden fs-small text-muted">{{ file!.filename }}</span>
    </div>
  </div>
}
